export default [
	{
		path: '/servicePack/detail/:id/:type?',
		name: 'servicePackDetail',
		component: () => import('@/views/service-pack/detail.vue')
	},
	{
		path: '/servicePack/detailByPush/:id/:patientId/:doctorId',
		name: 'servicePackDetail',
		component: () => import('@/views/service-pack/detail.vue')
	}
]
